module.exports = __webpack_public_path__ + "assets/33764e5664c4ee2b39de8a805cfc9471.png";